<div class="page">
	<wyzeweb-header></wyzeweb-header>
	<div class="page__content" (click)="closeSubNavigation()">
		<router-outlet></router-outlet>
	</div>
	<wyzeweb-footer></wyzeweb-footer>
</div>
